import moment from "moment";

// shared helper
export const calculateHalfMonthStats = (logs = []) => {
  const now = new Date();
  const year = now.getFullYear();
  const month = now.getMonth();
  const day = now.getDate();

  const filterPayableLogs = (logs) =>
    logs.filter(
      (l) =>
        l.clockIn &&
        l.duration > 0 &&
        !(l.reason || "").toLowerCase().includes("off") &&
        !(l.reason || "").toLowerCase().includes("payment")
    );

  const calculateHours = (logs) =>
    (Math.round(
      filterPayableLogs(logs).reduce((t, l) => t + l.duration, 0) / 15
    ) *
      15) /
    60;

  // First half (1–14 current month)
  const firstStart = new Date(year, month, 1);
  const firstEnd = new Date(year, month, 14, 23, 59, 59);

  // Second half logic
  let secondStart, secondEnd;
  if (day <= 14) {
    const prev = new Date(year, month - 1, 1);
    secondStart = new Date(prev.getFullYear(), prev.getMonth(), 15);
    secondEnd = new Date(prev.getFullYear(), prev.getMonth() + 1, 0, 23, 59, 59);
  } else {
    secondStart = new Date(year, month, 15);
    secondEnd = new Date(year, month + 1, 0, 23, 59, 59);
  }

  const normalizeDate = (d) => (d?.toDate ? d.toDate() : d);

  const firstLogs = logs.filter((l) => {
    const d = normalizeDate(l.clockIn);
    return d && d >= firstStart && d <= firstEnd;
  });
  
  const secondLogs = logs.filter((l) => {
    const d = normalizeDate(l.clockIn);
    return d && d >= secondStart && d <= secondEnd;
  });
  
  const countWorkedDays = (logs) =>
    new Set(
      logs
        .filter(
          (l) =>
            l.duration &&
            l.duration > 0 &&
            !(l.reason || "").toLowerCase().includes("off") &&
            !(l.reason || "").toLowerCase().includes("payment")
        )
        .map((l) =>
          moment(l.clockIn?.toDate ? l.clockIn.toDate() : l.clockIn).format(
            "YYYY-MM-DD"
          )
        )
    ).size;
  
  
  const firstDays = countWorkedDays(firstLogs);
  const secondDays = countWorkedDays(secondLogs);
  

  const firstHours = calculateHours(firstLogs);
  const secondHours = calculateHours(secondLogs);

  return {
    firstIsCurrent: day <= 14,
    secondIsCurrent: day > 14,

    firstHalfDays: firstDays,
    firstHalfHours: firstHours,
    firstHalfLunchHours: Math.max(0, firstHours - firstDays),

    secondHalfDays: secondDays,
    secondHalfHours: secondHours,
    secondHalfLunchHours: Math.max(0, secondHours - secondDays),

    firstHalfPayMonth: moment(new Date(year, month, 25)).format("MMMM"),
    secondHalfPayMonth: moment(
      day <= 14 ? new Date(year, month, 10) : new Date(year, month + 1, 10)
    ).format("MMMM"),
  };
};
